export var config = {
  background: '#221a0f',
  foreground: '#d3af86',
  selection: '#84613daa',
  selectionMatch: '#84613daa',
  cursor: '#d3af86',
  dropdownBackground: '#51412c',
  activeLine: '#5e452b52',
  matchingBracket: '#5e452b',
  keyword: '#98676a',
  storage: '#98676a',
  variable: '#dc3958',
  parameter: '#dc3958',
  function: '#7e602c',
  string: '#889b4a',
  constant: '#f79a32',
  type: '#f06431',
  class: '#f06431',
  number: '#f79a32',
  comment: '#a57a4c',
  heading: '#8ab1b0',
  invalid: '#dc3958',
  regexp: '#7e602c',
  tag: '#dc3958'
};